// recovery-repaginacao-03 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "A campanha entra no ar assim que você confirmar.": "La campaña entra en marcha apenas usted confirme.",
    "A partir de": "A partir de",
    "A que horas?": "¿A qué hora?",
    "Ao atingir, a campanha encerra antes do fim. O sistema confere a cada 15 minutos, então pode passar um pouco do teto entre uma checagem e outra.": "Al alcanzarlo, la campaña termina antes del final. El sistema verifica cada 15 minutos, así que puede pasarse un poco del tope entre una verificación y otra.",
    "Ativação não é recuperação — use com cuidado.": "Activación no es recuperación — úselo con cuidado.",
    "Está tudo certo para começar?": "¿Está todo listo para empezar?",
    "Há quanto tempo sem abastecer?": "¿Hace cuánto tiempo sin cargar combustible?",
    "Inclui quem parou há muito tempo.": "Incluye a quien dejó de cargar hace mucho tiempo.",
    "Incluir quem nunca abasteceu": "Incluir a quien nunca cargó combustible",
    "O aviso sai a cada troca de nível, com o texto escrito em cada um deles.": "El aviso sale en cada cambio de nivel, con el texto escrito en cada uno de ellos.",
    "Os dois são opcionais.": "Los dos son opcionales.",
    "Por onde o cliente fica sabendo?": "¿Por dónde se entera el cliente?",
    "Prioriza quem parou há menos tempo.": "Prioriza a quien dejó de cargar hace menos tiempo.",
    "Quem entra nesta campanha?": "¿Quién entra en esta campaña?",
    "Quem entra é decidido agora: o público não muda depois de criada.": "Quién entra se decide ahora: el público no cambia después de crearla.",
    "Quer estreitar mais o público?": "¿Quiere acotar más el público?",
    "Sem teto de dias": "Sin tope de días",
    "Tem teto de gasto?": "¿Tiene tope de gasto?",
};

export default catalogo;
